import { isMobile, isLite } from 'shared/vidio_helpers';
import { HERMES_HOST } from 'shared/env';
import GoogleTagAdapter from 'components/shared/GoogleTagAdapter/GoogleTagAdapter';
import GooglePublisherTag from 'components/shared/GooglePublisherTag/GooglePublisherTag';
import DesktopBannerAd from '../../desktop/BannerAd/BannerAd';
import MobileBannerAd from '../../mobile/BannerAd/BannerAd';
import Tercept from '../Tercept/Tercept';

const Cookies = require('js-cookie');

export default class BannerAd {
  static setup() {
    if(!BannerAd.shouldSetupBannerAd()) {
      return;
    }

    if (window.__adsConfig && window.__adsConfig.request_to_hermes == "true") {
      BannerAd.getHermesAdUnit();
    } else {
      BannerAd.setupDisplayAds();
    }
  }

  static shouldSetupBannerAd() {
    if(window.kmklabs === undefined || window.kmklabs.gpt === undefined) {
      return false;
    }

    if(window.__adsConfig && window.__adsConfig.enable_premier_user_banner_ads == "true") {
      return true;
    }

    var premiumCookie = Cookies.get("_vidio");
    if(window.isUserSignedIn && premiumCookie === "true") {
      return false;
    }

    return true;
  }

  static setBannerAd(container_id, ad_slot_name, ad_unit, ad_size, setBannerFunction, refreshFunction) {
    var bannerContainer = document.getElementById(container_id);
    
    if(bannerContainer) {
      var bannerDiv = document.createElement("div");
      bannerDiv.id = ad_slot_name;
      bannerContainer.appendChild(bannerDiv);

      setBannerFunction(ad_unit, ad_size);

      if(refreshFunction){
        GoogleTagAdapter.push(refreshFunction);
      }
    }
  }

  static isMobileAds() {
    return isMobile() || isLite();
  }

  static setupDisplayAds() {
    if(this.isMobileAds()) {
      MobileBannerAd.setup();
    } else {
      DesktopBannerAd.setup();
    }

    Tercept.setTargeting();
    GooglePublisherTag.displayAllBanners();
  }

  static getHermesAdUnit() {
    var endpoint = BannerAd.hermesEndpoint();

    var xhr = new XMLHttpRequest();
    xhr.timeout = 1000;
    xhr.open("GET", endpoint);

    xhr.onload = () => {
      BannerAd.xhrHermesLoaded(xhr);
    };

    xhr.send();    
  }

  static xhrHermesLoaded(xhr) {
    if (xhr.status == 200 && xhr.response) {
      BannerAd.setHermesAdUnitSize(xhr.response);
      BannerAd.setupDisplayAds();
    }
  }

  static hermesEndpoint() {
    var url = HERMES_HOST + "/api/tags?";
    var query = BannerAd.createHermesQueryParams();

    return url + query;
  }

  static createHermesQueryParams() {
    var device = this.isMobileAds() ? "mobile" : "desktop";
    var contentId = window.kmklabs.video.id;
    var ownerId = window.kmklabs.video.owner_id;
    var contentType = window.kmklabs.video.content_type;
  
    return `d=${device}&cid=${contentId}&cuid=${ownerId}&ct=${contentType}`;
  }

  static setHermesAdUnitSize(json) {
    var displayAd = JSON.parse(json).display;

    if(displayAd && displayAd.leaderboard && displayAd.leaderboard.ad_unit && displayAd.leaderboard.size.length > 0) {
      var lb_ad_slot = displayAd.leaderboard.ad_unit;
      var lb_ad_size = BannerAd.getSizes(displayAd.leaderboard.size);
      window.kmklabs.gpt.leaderboard_ad_unit = lb_ad_slot;
      window.kmklabs.gpt.leaderboard_ad_size = lb_ad_size;
    }
    
    if(displayAd && displayAd.top_banner && displayAd.top_banner.ad_unit && displayAd.top_banner.size.length > 0) {
      var tb_ad_slot = displayAd.top_banner.ad_unit;
      var tb_ad_size = BannerAd.getSizes(displayAd.top_banner.size);
      window.kmklabs.gpt.top_banner_ad_unit = tb_ad_slot;
      window.kmklabs.gpt.top_banner_ad_size = tb_ad_size;
    }

    if(displayAd && displayAd.middle_banner && displayAd.middle_banner.ad_unit && displayAd.middle_banner.size.length > 0) {
      var mb_ad_slot = displayAd.middle_banner.ad_unit;
      var mb_ad_size = BannerAd.getSizes(displayAd.middle_banner.size);
      window.kmklabs.gpt.middle_banner_ad_unit = mb_ad_slot;
      window.kmklabs.gpt.middle_banner_ad_size = mb_ad_size;
    }

    if(displayAd && displayAd.pause_ad && displayAd.pause_ad.ad_unit && displayAd.pause_ad.size.length > 0) {
      var pause_ad_slot = displayAd.pause_ad.ad_unit;
      var pause_ad_size = BannerAd.getSizes(displayAd.pause_ad.size);
      window.kmklabs.gpt.pause_ad_unit = pause_ad_slot;
      window.kmklabs.gpt.pause_ad_size = pause_ad_size;
    }

    if(displayAd && displayAd.overlay && displayAd.overlay.ad_unit && displayAd.overlay.size.length > 0) {
      var overlay_ad_slot = displayAd.overlay.ad_unit;
      var overlay_ad_size = BannerAd.getSizes(displayAd.overlay.size);
      window.kmklabs.gpt.overlay_ad_unit = overlay_ad_slot;
      window.kmklabs.gpt.overlay_ad_size = overlay_ad_size;
    }
  }

  static getSizes(sizes) {
    var ad_sizes = "[";
    sizes.forEach(element => {
      ad_sizes += `[${element.width},${element.height}],`;
    });
    ad_sizes = ad_sizes.substring(0, ad_sizes.length -1);
    ad_sizes += "]";  

    return ad_sizes;
  }
}